import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import morereport from "../../../../assets/images/headerDesk/Reports/morereports.svg";
import morereportmob from "../../../../assets/images/headerDesk/Reports/morereport-mob.svg";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import AllReportMob from "@frameworks/web/components/header/HeaderMob/AllReportMob";
const MoreReports = (props) => {
    const device = DeviceContext();
    const [isViewReport, setIsViewReport] = useState(null);
    const [moreReport, setMoreReport] = useState(false);
    const onCloseGoBackFunction = () => {
        setMoreReport(false);
    };
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-3 pb-5 pt-4" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement("div", null,
                    React.createElement("span", { className: "aligncenteritem" },
                        React.createElement("img", { src: morereport })),
                    React.createElement("span", { className: "DMSansMedium_18_500 txt-midnight-blue aligncenteritem mgt-30" }, "Discover More Reports"),
                    React.createElement("span", { className: "DMSanM_14_500 txt_secondary-gray aligncenteritem" },
                        "Choose from our 30+ reports ",
                        React.createElement("br", null),
                        "generated for you!")),
                React.createElement("div", { className: "mgt-20 aligncenteritem" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "View All Reports", className: "small-edbutton mb-3", onClick: () => {
                            props.setMoreReport(true);
                        } })))))) : (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 px-3  pt-4" },
            React.createElement(Col, { lg: 12, className: "px-0 grid-2-morereport" },
                React.createElement("div", null,
                    React.createElement("span", { className: "aligncenteritem" },
                        React.createElement("img", { src: morereportmob }))),
                React.createElement("div", null,
                    React.createElement("span", { className: "DMSansMedium_18_500  d-flex txt-midnight-blue aligncenteritem" }, "Discover More Reports"),
                    React.createElement("span", { className: "DMSanM_14_500 txt_secondary-gray aligncenteritem d-flex pt-3 line-20 " },
                        "Choose from our 30+ reports ",
                        React.createElement("br", null),
                        "generated for you!"),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "View All Reports", className: "small-edbutton mb-3 mgt-15", onClick: () => {
                            setIsViewReport(true);
                        } })))),
        React.createElement("div", { className: "mb-genericSidebar support-genericSidebar" },
            React.createElement(GenericDrawer, { show: isViewReport, setShow: setIsViewReport, headerComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "p-3" },
                        React.createElement("span", { className: "DMSan_14_700 txt-midnight-blue" }, "All Report"))), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "p-3" },
                        React.createElement(AllReportMob, null))), parentClass: "z-index-high support-content-drp " }))))));
};
export default MoreReports;
